import { GtmSdk } from "..";

const SERVER_MOCK = {
  push: () => {
    throw new Error("cannot call on server");
  },
};

const getClientDataLayer = (): DataLayer => {
  window.dataLayer = (window.dataLayer ?? []) as DataLayer;
  return window.dataLayer;
};

export const createGtmInstance = (): GtmSdk => {
  return new GtmSdk(
    typeof window !== "undefined" ? getClientDataLayer() : SERVER_MOCK,
  );
};
